"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDockerRunningLanguage = exports.dockerRunningLanguages = exports.ANIMATION = exports.CHARACTER = exports.CSS = exports.HTML = exports.JS = undefined;

var _socColors = require("../style/soc-colors");

var JS = exports.JS = {
  ext: "js",
  type: "js",
  display: "JavaScript",
  color: _socColors.socColorJavascript
};
var HTML = exports.HTML = {
  ext: "html",
  type: "html",
  display: "HTML",
  color: _socColors.socColorHtml
};
var CSS = exports.CSS = {
  ext: "css",
  type: "css",
  display: "CSS",
  color: _socColors.socColorCss
};
var CHARACTER = exports.CHARACTER = {
  ext: "character",
  type: "character",
  display: HTML.display,
  color: HTML.color
};
var ANIMATION = exports.ANIMATION = {
  ext: "animation",
  type: "animation",
  display: JS.display,
  color: JS.color
};
var dockerRunningLanguages = exports.dockerRunningLanguages = [JS.type];

var isDockerRunningLanguage = exports.isDockerRunningLanguage = function isDockerRunningLanguage(language) {
  return dockerRunningLanguages.indexOf(language) !== -1;
};